namespace Gordic.Vyp.Lists
{
    @Decorators.gcontent
    export class ProvedenaVypraveniZasilekListPage extends GContentBase<Wfl.ListAC.WflListBaseAC>
    {
        model: Gordic.Wfl.Interface.GSeznamFilterBaseDto;

        onContentReady()
        {
            var that = this;
            Wfl.ListAC.WflListBaseAC.InitList(this);
            Wfl.ListAC.WflListBaseAC.AddBaseActionsToMenu(this);
            Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            
            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj)
                {       
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: that.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favorites: "all",                           // defaultní oblíbené
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "vyp_ptm_provyp" }),
                    poVyhledaniZobrazit: "OblibenePodminky",
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                })

            this.cellActiveProp = function (ev, row) {
                if (row.cellInfo.column && row.cellInfo.column!.name === "xx")
                {

                }
                if (that.PreviewDiv !== null && that.PreviewDiv !== undefined) {
                    if (that.PreviewDiv.gtab("option").opened) {
                        if (row != null && row.cellInfo != null && row.cellInfo.data != null) {
                            Wfl.ListAC.WflListBaseAC.EnablePreview(that, true);
                             that.LoadPreview(that, row.cellInfo.data);
                        } else {
                            Wfl.ListAC.WflListBaseAC.EnablePreview(that, false);
                        }
                    }
                }
            };
            this.CreateGrid();
            this.CreateGridObsah();
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateGridObsah(): void
        {
            this.PreviewDiv = $("<div>").appendTo(this.element).gcontent("Gordic.Vyp.WebControls.ProvedenaVypraveniZasilekObsahListPage", { uid: "ProvedenaVypraveniZasilekObsahListPage" }).gtab({ title: "Obsah", opened: true });
        }

        LoadPreview = Utils.debounced(function (content: GContentType<ProvedenaVypraveniZasilekListPage>, row: Gordic.Wfl.Interface.SeznamProvedenychVypraveniZasilekDto): void {
            if (content && content.PreviewDiv) { var previewDivCnt = $.content(content.PreviewDiv); previewDivCnt.loadingAwait.done(() => { previewDivCnt.load({ TridVyp: row.trid_vyp, ZpusobDorProp: row.zpusob_dor }) }); }
        }, 300);
    
        CreateGrid(): void {
            var that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datVypraveniColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.zpusobDoruceniColumn());
            gf.addTextColumn({ name: "dor_sluzba_txt", caption: "jres:23900023", width: 120, }) //RC 23900023 : Doručovací služba
            gf.addTextColumn({ name: "posta", caption: "jres:23900031", width: 120, }) //RC 23900031 : Pošta
            gf.addTextColumn({ name: "nazev_akt_su", caption: "jres:23900032", width: 200, }) //RC 23900032 : Vypravující
            gf.addTextColumn({ name: "nazev_fun_zmenuprov", caption: "jres:23900033", width: 200, }) //RC 23900033 : Poslední změnu provedl
            this.gridOptions = {};
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        LoadData(filtr?: Wfl.Interface.GSeznamFilterBaseDto) {
                var that = this;
                Gin.Globals.ShowWaitLoadData(this);
                //nacteni dat do gridu
                this.call<Gordic.Wfl.Interface.SeznamProvedenychVypraveniZasilekDto[]>("LoadData", { model: filtr })
                    .done(function (data) {
                        var view = new Gordic.Data.View(data, {
                            key: that.IDPrimaryKeyGridu
                        });

                        //key je dulezity kvuli pripadnemu vyhledavani radku
                        that.mainGrid.ggrid("setData", view); //true = prekresleni gridu
                    })
                    .always(function () {
                        Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                    });
                //if (filtr) that.model = filtr;
        }

        ReloadData()
        {
            this.LoadData(this.model);
        }
   
        CreateFilterForms()
        {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900173", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" });  //RC 23900173 : Kompletní filtr

            filterForm.addSection()
                .addRow({ label: "jres:23900034", name: "datum" }) //RC 23900034 : Datum vypravení

                .addField("gdatecombobox", {
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    //initialValue: { value: this.model.Datum },    
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });

            filterForm.addSection().addRow().addField("gcheck", "", { name: "Vlastni", model: "model.Vlastni=value", label: "jres:23900011" }); //RC 23900011 : Vlastní

            return [filterForm];
        }
    }
}

